import {mk_strings} from "./mk";
import {en_strings} from "./eng";

export const languages = {
  mk: mk_strings,
  en: en_strings
};